
$(document).scroll(function(){
    if($(document).scrollTop() >= 20){
        $('.cyb-header-bottom').addClass('scrolled');
    }
    else{
        $('.cyb-header-bottom').removeClass('scrolled');
    }
});

$(document).ready(function(){
  $(document).scroll();
  
  var ht = $('.utility-bar').outerHeight();
  $('.cyb-mobile-menu').css('height','calc(100vh - '+(ht)+'px)');

  $('body').on('click','.hamburger',function(){
    $('body').toggleClass('locked');
    $(this).toggleClass('is-active');
    $('.cyb-mobile-menu').slideToggle('fast');
  });

  $('body').on('click','.cyb-mobile-nav-link.nav-has-children',function(){
    var menu = $(this).next();
    if(menu.hasClass('open')){
      $('.cyb-mobile-nav-dropdown').removeClass('open');
    }
    else{
      $('.cyb-mobile-nav-dropdown').removeClass('open');
      menu.addClass('open');
    }
  });
});